let root: HTMLElement | null;

export const getRootElement = (): HTMLElement | null => {
    if (typeof document === 'undefined') {
        return null;
    }

    if (!root) {
        root = document.getElementById('root');
    }

    if (!root) {
        root = document.getElementById('__next');
    }

    return root;
};
